import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { WalletService } from './services/wallet.service';

@Component({
  imports: [IonApp, IonRouterOutlet],
  selector: 'joy-root',
  template: `
    <ion-app>
      <ion-router-outlet />
    </ion-app>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 100%;
      }
    `,
  ],
})
export class AppComponent {
  private readonly translate = inject(TranslateService);
  private readonly wallet = inject(WalletService);

  constructor() {
    this.translate.setDefaultLang('zh-TW');
    let lang = 'zh-TW';
    try {
      lang = localStorage.getItem('joy_lang') || 'zh-TW';
    } catch {
      // Storage unavailable
    }
    this.translate.use(lang);
  }
}
